// extracted by mini-css-extract-plugin
export var darkBackgroundOverlay = "header-module--dark-background-overlay--0629a";
export var desktopNav = "header-module--desktop-nav--95cbc";
export var hamburger = "header-module--hamburger--93416";
export var hamburgerNav = "header-module--hamburger-nav--b6f62";
export var line1 = "header-module--line1--52ae5";
export var line2 = "header-module--line2--efdad";
export var line3 = "header-module--line3--d5eca";
export var lineOneMove = "header-module--line-one-move--9828a";
export var lineOneMoveBack = "header-module--line-one-move-back--d0911";
export var lineThreeMove = "header-module--line-three-move--010a1";
export var lineThreeMoveBack = "header-module--line-three-move-back--5b25d";
export var mainHeader = "header-module--main-header--2e6d2";
export var mobilenavcontainer = "header-module--mobilenavcontainer--11dfd";
export var open = "header-module--open--33b5f";
export var reversed = "header-module--reversed--d3263";
export var scrolled = "header-module--scrolled--37ab9";